import type { Components } from '@mui/material/styles';
import { tabClasses } from '@mui/material/Tab';
import { tabsClasses } from '@mui/material/Tabs';

import type { Theme } from '../types';

export const MuiTabs = {
  styleOverrides: {
    flexContainer: { [`&:not(.${tabsClasses.flexContainerVertical})`]: { gap: '16px' } },
    indicator: { height: '3px', borderTopLeftRadius: '3px', borderTopRightRadius: '3px' },
    vertical: {
      [`& .${tabsClasses.indicator}`]: {
        borderBottomRightRadius: '3px',
        borderTopRightRadius: '3px',
        left: 0,
        right: 'auto',
        width: '3px',
      },
      [`& .${tabClasses.root}`]: { justifyContent: 'flex-start', paddingInline: '16px' },
    },
  },
} satisfies Components<Theme>['MuiTabs'];
